import React from 'react'
import { Box, Container, Grid, Typography, Link, Stack } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

export default function Footer() {
  return (
    <Box component="footer" sx={{ mt: 8, py: 6, backgroundColor: '#fff', borderTop: '1px solid rgba(0,0,0,0.08)' }}>
      <Container className="container">
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>Bloomington Clean Services</Typography>
            <Typography variant="body2" color="text.secondary">
              Locally owned, serving Bloomington, Ellettsville, Bedford, Martinsville, and nearby communities.
            </Typography>
            <Stack spacing={0.5} sx={{ mt: 2 }}>
              <Typography variant="body2"><strong>Address:</strong> 123 W Kirkwood Ave, Bloomington, IN 47404</Typography>
              <Typography variant="body2"><strong>Phone:</strong> <Link href="tel:+18125550199">(812) 555-0199</Link></Typography>
              <Typography variant="body2"><strong>Email:</strong> <Link href="mailto:hello@bloomingtoncleanservices.com">hello@bloomingtoncleanservices.com</Link></Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Quick Links</Typography>
            <Stack spacing={1}>
              <Link component={RouterLink} to="/">Home</Link>
              <Link component={RouterLink} to="/about">About</Link>
              <Link component={RouterLink} to="/services">Services</Link>
              <Link component={RouterLink} to="/blogs">Blogs</Link>
              <Link component={RouterLink} to="/deals">Deals</Link>
              <Link component={RouterLink} to="/estimate">Free Estimate</Link>
              <Link component={RouterLink} to="/contact">Contact</Link>
            </Stack>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Hours</Typography>
            <Typography variant="body2">Mon–Fri: 8:00 AM – 6:00 PM</Typography>
            <Typography variant="body2">Sat: 9:00 AM – 4:00 PM</Typography>
            <Typography variant="body2">Sun: Closed</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display:'block', mt:2 }}>
              *For mailing only. Service area is broader than mailing address.
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} Bloomington Clean Services. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}
